import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowRight } from "lucide-react";
import SectionHeader from "@/components/common/SectionHeader";
import { getImageUrl } from "@/lib/api";

const PLACEHOLDER = [
  "https://images.unsplash.com/photo-1533734635438-fa92e72a1f0e?w=800&q=80",
  "https://images.unsplash.com/photo-1611087802810-046bb671e644?w=800&q=80",
  "https://images.pexels.com/photos/15773044/pexels-photo-15773044.jpeg?w=800",
  "https://images.unsplash.com/photo-1549431971-f54b3f5c82d8?w=800&q=80",
  "https://images.unsplash.com/photo-1747778148316-4a8eeb132d48?w=800&q=80",
  "https://images.pexels.com/photos/17565235/pexels-photo-17565235.png?w=800",
  "https://images.unsplash.com/photo-1665664660924-255a6167f498?w=800&q=80",
  "https://images.unsplash.com/photo-1526795443948-005b48ce4791?w=800&q=80",
];

export default function GalleryPreview() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/gallery", { params: { limit: 8 } })
      .then((r) => setItems(r.data.items || []))
      .catch(() => {});
  }, []);

  const media = items.length > 0
    ? items.slice(0, 8).map((i) => i.media_url || i.thumbnail)
    : PLACEHOLDER;

  return (
    <section className="section-y bg-[var(--bg)]" data-testid="home-gallery-preview">
      <div className="container-sf">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-12">
          <SectionHeader
            eyebrow="Galeri"
            title="Momen"
            accentTitle="di lapangan"
            description="Kumpulan foto kegiatan Sauyunan Foundation bersama komunitas di seluruh Nusantara."
          />
          <Link to="/galeri" className="btn-outline shrink-0" data-testid="gallery-see-all">
            Lihat Galeri <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {media.slice(0, 8).map((src, i) => (
            <div
              key={i}
              className={`relative overflow-hidden rounded-2xl bg-slate-100 group ${
                i === 0 ? "row-span-2 aspect-[3/4] md:aspect-auto" : "aspect-[4/3]"
              }`}
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={getImageUrl(src)}
                alt={`Sauyunan aktivitas ${i + 1}`}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
